import { useContext } from "react";
import { Link } from "react-router-dom";
import { SiteContentContext } from "../context/SiteContentContext.jsx";
import { useLocalePath } from "../hooks/useLocalePath";
import ContentText from "./contentText.jsx";

const Footer = () => {
  const { localePath } = useLocalePath();
  const { getContent } = useContext(SiteContentContext);

  return (
    <footer className="bg-dark text-gray-300 text-sm">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company info */}
          <div>
            <Link
              to={localePath("/")}
              className="text-inverse text-lg font-bold hover:text-inverse"
            >
              AS Maskiner
            </Link>
            <p className="mt-2 text-gray-400">
              <ContentText
                contentKey="footer.company_description"
                fallback="Ledande leverantör av maskiner för trä- och plastindustrin."
              />
            </p>
            <p className="mt-2 text-gray-500 text-xs">Org.nr: 559447-9486</p>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="text-inverse font-semibold mb-3">
              <ContentText
                contentKey="footer.nav_heading"
                fallback="Navigation"
              />
            </h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to={localePath("/catalogue")}
                  className="hover:text-inverse transition-colors"
                >
                  <ContentText contentKey="nav.products" fallback="Produkter" />
                </Link>
              </li>
              <li>
                <Link
                  to={localePath("/about-us")}
                  className="hover:text-inverse transition-colors"
                >
                  <ContentText contentKey="nav.about_us" fallback="Om oss" />
                </Link>
              </li>
              <li>
                <Link
                  to={localePath("/news")}
                  className="hover:text-inverse transition-colors"
                >
                  <ContentText contentKey="nav.news" fallback="Nyheter" />
                </Link>
              </li>
              <li>
                <Link
                  to={localePath("/jobs")}
                  className="hover:text-inverse transition-colors"
                >
                  <ContentText contentKey="nav.jobs" fallback="Karriär" />
                </Link>
              </li>
              <li>
                <Link
                  to={localePath("/contact")}
                  className="hover:text-inverse transition-colors"
                >
                  <ContentText contentKey="nav.contact" fallback="Kontakt" />
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-inverse font-semibold mb-3">
              <ContentText
                contentKey="footer.info_heading"
                fallback="Information"
              />
            </h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to={localePath("/terms-and-conditions")}
                  className="hover:text-inverse transition-colors"
                >
                  <ContentText
                    contentKey="footer.terms_label"
                    fallback="Allmänna villkor"
                  />
                </Link>
              </li>
              <li>
                {/**
                 Temp disabled.
                 <Link to={localePath("/faq")} className="hover:text-inverse transition-colors">
                 <ContentText contentKey="footer.faq_label" fallback="Frågor och svar" />
                 </Link>
                 */}
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-inverse font-semibold mb-3">
              <ContentText contentKey="nav.contact" fallback="Kontakt" />
            </h3>
            <ul className="space-y-2">
              <li>
                <a
                  href={`tel:${getContent("company.phone", "+4640122700")}`}
                  className="hover:text-inverse transition-colors"
                >
                  <ContentText
                    contentKey="company.phone"
                    fallback="+4640122700"
                  />
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${getContent("company.email", "info@asmaskiner.se")}`}
                  className="hover:text-inverse transition-colors"
                >
                  <ContentText
                    contentKey="company.email"
                    fallback="info@asmaskiner.se"
                  />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-gray-700 text-gray-500 text-xs">
          <p>
            © {new Date().getFullYear()}{" "}
            <ContentText
              contentKey="footer.copyright"
              fallback="AS Maskiner Sverige AB. Alla rättigheter förbehållna."
            />
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
